import React, { useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line

import TwoColumnWithImage from "components/testimonials/TwoColumnWithImage";
import cogoToast from "cogo-toast";

/* 
const Container = styled.div(props => [
    `background-image: url(${props.i});`,  
    tw`relative -mx-8 mt-0 bg-center bg-cover`,  
  ]);
  
  const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-primary-500 opacity-50 bg-black`;
  
  const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-xl mx-auto`;
  const Block = tw.div`pt-0 pb-32 px-4 flex justify-between items-center`;
  const Button = styled.button`
    ${props =>  css`
        ${tw`bg-gray-lightest font-semibold underline mt-2 py-2 px-4`} 
        ${!props?.session && `from-gray-300 to-gray-500 border-gray-200 text-gray-300 cursor-not-allowed`}
    `}`
*/
    
const ContainerDiv = tw.div`px-10 md:px-12 sm:px-10 lg:px-px justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none`
const ContainInner = tw.div`relative w-auto my-2 mx-auto max-w-3xl`
const ContainerNext = tw.div`border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none`
const ContainerNextInner = tw.div`flex items-start justify-between p-2 border-b border-solid border-teal-200 rounded-t`
const ContainerH5 = tw.p`font-normal m-0 p-0 text-center`
const Button1 = tw.button`p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none`
const Button1Span = tw.span`bg-transparent text-black h-4 w-6 text-2xl block outline-none focus:outline-none`
const BodyDiv = tw.div`relative p-2 flex-auto`
const BodyDivInnerP = tw.p`my-4 text-teal-500 text-lg leading-relaxed`
const FooterContainer = tw.div`flex items-center justify-end p-2 border-t border-solid border-teal-200 rounded-b`
const FooterButton1 = tw.button`text-red-500 bg-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150`
const FooterButton2 = tw.button`bg-teal-500 text-white active:bg-teal-600 font-bold uppercase text-sm px-6 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150`
const OverlayDiv = tw.div`opacity-75 fixed inset-0 z-40 bg-black`

// Globally unique id for each basket feature line. Previously features were
// keyed by `${type}-${measure}`, so two lines sharing a type+measure collided
// and edit/delete touched every matching line. A true unique id fixes that.
const genFeatureId = () =>
  `feat_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;

export default function Modal(props) {
  //const [showModal, setShowModal] = React.useState(false);
  
  const [ typeIndex, setTypeIndex ] = useState(0)
  const [ measureIndex, setMeasureIndex ] = useState(0)
  const [ quantity, setQuantity ] = useState(0)

  const { showModal, setShowModal} = props
  //console.log(props.product)

  const onClick = () => {
    if (quantity <= 0) {
        cogoToast.warn('Quantity cannot be zero! Cancel instead.')
        return
    }  
        const verb = quantity > 1 ? 'have' : 'has'

        const selectedType = props.product?.type?.[typeIndex]
        const selectedMeasure = selectedType?.Measure_and_price?.[measureIndex]
        const type = selectedType?.title
        const measure = selectedMeasure?.measure
        const price = selectedMeasure?.price

        if (!type || !measure || !price) {
            cogoToast.warn('Please select a valid type and measure before adding to basket')
            return
        }

        let items = props.items || []
        let item = items.find((it) => it?.title === props.product?.title)

        const featureId = genFeatureId();
        if (item?.title) {
            item.basket = [...(item?.basket || []), { id: featureId, type, measure, quantity, price, total: Number(quantity) * Number(price) }]
        } else {
            item = {
                id: props?.product.id ?? props?.product.title,
                title: props?.product.title,
                imageSrc: props?.product.imageSrc,
                basket: [{ id: featureId, type, measure, quantity, price, total: Number(quantity) * Number(price) }]
            }
        }

        props.addItemToBasket(item)

        cogoToast.success(`Success! ${quantity} ${measure}(s) of ${props.product?.title} (${type}) ${verb} been added to basket`)
        setShowModal(false)

        setQuantity(0)
  }
  
  return (
    <>
     {/*  <button
        className="bg-pink-500 text-white active:bg-pink-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
        type="button"
        onClick={() => setShowModal(true)}
      >
        Open regular modal
      </button> */}
      {showModal ? (
        <>
            <ContainerDiv>
                <ContainInner>
                {/*content*/}
                <ContainerNext>
                    {/*header*/}
                    <ContainerNextInner>
                    <ContainerH5>
                        {`Select type and measure of ${props.product?.title} you want to buy...`}
                    </ContainerH5>
                    <Button1
                        onClick={() => {
                            setShowModal(false)
                            setQuantity(0)
                        }}
                    >
                        <Button1Span>
                        x
                        </Button1Span>
                    </Button1>
                    </ContainerNextInner>
                    {/*body*/}
                    <BodyDiv>
                    {/* <BodyDivInnerP>
                        Touch and scroll to see other options
                    </BodyDivInnerP> */}
                    {/* <TouchAndDrag type={props.product.type} />*/}
                    <TwoColumnWithImage 
                        types={props.product.type} 
                        setTypeIndex = {setTypeIndex}
                        measureIndex = {measureIndex}
                        setMeasureIndex = {setMeasureIndex}
                        quantity = {quantity}
                        setQuantity = {setQuantity}
                    />
                    </BodyDiv>
                    {/*footer*/}
                    <FooterContainer>
                    <FooterButton1
                        type="button"
                        onClick={() => {
                            setShowModal(false)
                            setQuantity(0)
                        }}
                    >
                        Cancel
                    </FooterButton1>
                    <FooterButton2
                        type="button"
                        onClick={onClick}
                    >
                        Add To Basket
                    </FooterButton2>
                    </FooterContainer>
                </ContainerNext>
                </ContainInner>
            </ContainerDiv>
            <OverlayDiv></OverlayDiv>
        </>
      ): null} 
        
    </>
  );
}
